import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

const PublicRoute = () => {
    return localStorage.getItem('idToken') ? <Navigate to={'/cuenta/dashboard'} /> : <Outlet />
}

export default PublicRoute